module.exports = {"available":"Vapaa","booked":"Varattu","occupied":"Asuttu","booked-occupied":"Varattu / Asuttu","used":"käytetty","until":"saakka","all-day":"koko päivän","page_over_total":"sivu {page}/{total}","room-name":"Tilan nimi","current-booking":"Varaus","next-booking":"Seuraava varaus","unknown":"Ei tiedossa","floors":"Kerros","today":"Tänään","no_bookings":"Ei varauksia tänään","no_information":"Ei tietoja saatavilla","description":"Kuvaus","capacity":"Kapasiteetti","allocated":"Myönnetty","booked-occupied-allocated":"Varattu / Asuttu / Myönnetty"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/fi.json
// module id = /UD6
// module chunks = 2